import ErrorUtil from '@utils/ErrorUtil';
import ProjectUtil from '@utils/ProjectUtil';
import moment from 'moment';
import Vue from 'vue';

export default {

    setApiKey(state, apiKey) {
        state.apiKey = apiKey;
        localStorage.setItem('api_key', apiKey);
    },

    setAlert(state, alert) {
        state.alerts.push({
            key: 'alert-' + moment().unix(),
            message: alert.message,
            type: alert.type,
        });
    },

    setAlertSuccess(state, message) {
        state.alerts.push({
            key: 'alert-' + moment().unix(),
            message: message,
            type: 'success',
        });
    },

    setAlertError(state, message) {
        state.alerts.push({
            key: 'alert-' + moment().unix(),
            message: message,
            type: 'danger',
        });
    },

    setAlertWithError(state, error) {
        state.alerts.push({
            key: 'alert-' + moment().unix(),
            message: ErrorUtil.error(error),
            type: 'danger'
        });
    },

    removeAlert(state, key) {
        let index = state.alerts.indexOf(state.alerts.find(a => a.key === key));
        state.alerts.splice(index, 1);
    },

    loading(state, loading) {
        state.loading = loading;
    },

    refreshing(state, refreshing) {
        state.refreshing = refreshing;
    },

    showModal(state, show) {
        state.showModal = show;
    },

    setUser(state, user) {
        state.user = user;
        // Set project theme.
        if (user.project) {
            ProjectUtil.setTheme(user.project.theme);
        }
        // Track user.
        window.cp('identify', {
            user_token: user.jwt,
            user_id: user.id,
            email: user.email,
            name: user.name,
            signed_up_at: user.created_at,
        });
    },

    setCompany(state, company) {
        Vue.set(state.user, 'company', company);
    },

    setProject(state, project) {
        Vue.set(state.user, 'project', project);
        // Set project theme.
        ProjectUtil.setTheme(project.theme);
    },

    setInviteToken(state, token) {
        state.inviteToken = token;
    },

    setRedirect(state, name) {
        state.redirect = name;
    },

    logout(state) {
        state.apiKey = null;
        localStorage.removeItem('api_key');
        window.Beacon('logout');
    },

}